import React, { useState } from "react";
import axios from "axios";
import {
  Form,
  Row,
  Col,
  Button,
} from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import logo from "../assets/img/logo-dark.svg";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function OtpVerification() {
  const [otp, setOtp] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const email = localStorage.getItem('email'); 

  const handleOtpSubmit = (e) => {
    e.preventDefault();

    axios
      .post(
        "http://3.131.161.69:5000/admin/verify-otp",
        { email: email, otp: otp }
      )
      .then((response) => {
        console.log('========response',response);
        if (response.status === 200) {
          toast.success("Otp verified successfully");
          localStorage.setItem("email", email);
          navigate("/reset-password"); 
        }
      })
      .catch((error) => {
        console.error("OTP verification failed", error);
        setError("Invalid OTP. Please try again.");
      });
  };

  return (
    <React.Fragment>
      <Row className="justify-content-center">
        <Col lg={6} className="loginform">
          <div className="loginmain_div maxwidth500 mx-auto">
            <div className="headlogin_div mb-4">
              <img className="loginlogo_img" src={logo} alt=""/>
              <h2>OTP Verification</h2>
              <p>Please enter the 6-digit verification code sent to your registered email address.</p>
            </div>
            <Form onSubmit={handleOtpSubmit}>
              <Form.Group className="mb-4 form-group">
                <Form.Label>OTP</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter your OTP"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  required
                />
              </Form.Group>
              {error && <p className="text-danger">{error}</p>}
              <Button type="submit" className="btn btn-primary w-100 mt-3">Verify OTP</Button>
              <p className="formfooter text-center mt-3">Back To <Link to="/">Login</Link></p>
            </Form>
          </div>
        </Col>
      </Row>
      <ToastContainer />
    </React.Fragment>
  );
}
